import { useCallback } from 'react'

import { useHistory } from 'react-router'

import { useAppRoutes } from '@webapp/hooks'
import {
  GlobalSearchResultStatuses,
  type GlobalSearchResultStatusEnum,
} from '../../value-objects/enums/GlobalSearchResultStatusEnum'
import {
  GlobalSearchResultTypes,
  type GlobalSearchResultTypeEnum,
} from '../../value-objects/enums/GlobalSearchResultTypeEnum'

interface IGlobalSearchNavigateParams {
  type: GlobalSearchResultTypeEnum
  uuid: uuid
  id: string
  status: Nullable<GlobalSearchResultStatusEnum>
}

interface IUseGlobalSearchNavigationResult {
  navigate: (params: IGlobalSearchNavigateParams) => void
}

export const useGlobalSearchNavigation =
  (): IUseGlobalSearchNavigationResult => {
    const { url } = useAppRoutes()
    const history = useHistory()

    const navigate = useCallback(
      ({ type, uuid, id, status }: IGlobalSearchNavigateParams): void => {
        switch (type) {
          case GlobalSearchResultTypes.ORDER_REQUEST:
            history.push(url('OrderDetailsPage', { uuid, tab: 'details' }))
            return
          case GlobalSearchResultTypes.EXPENSE_REQUEST:
            window.location.assign(url('ExpenseDetailPage', { uuid }))
            return
          case GlobalSearchResultTypes.TRAVEL_REQUEST:
            window.location.assign(url('TravelRequestDetailsPage', { uuid }))
            return
          case GlobalSearchResultTypes.PURCHASE_ORDER:
            history.push(url('PurchaseOrderDetailsPage', { uuid }))
            return
          case GlobalSearchResultTypes.BILL:
            if (status === GlobalSearchResultStatuses.DRAFT) {
              history.push(url('BillCreatePage', { uuid }))
            } else {
              history.push(url('BillRequestDetailsPage', { uuid }))
            }
            return
          case GlobalSearchResultTypes.PAYMENT:
            if (status === GlobalSearchResultStatuses.DRAFT) {
              history.push(url('PaymentPreparePage', { uuid }))
            } else {
              history.push(url('PaymentDetailsPage', { uuid }))
            }
            return
          case GlobalSearchResultTypes.CATALOG_ITEM:
            history.push(
              `${url('ProcurementPage')}?search=${encodeURIComponent(id)}`
            )
            return
          case GlobalSearchResultTypes.VENDOR:
            history.push(
              url('VendorManagementPage', { id: uuid, tab: 'overview' })
            )
            return
          case GlobalSearchResultTypes.CONTRACT:
            if (
              status === GlobalSearchResultStatuses.DRAFT ||
              status === GlobalSearchResultStatuses.AI_DRAFT ||
              status === GlobalSearchResultStatuses.AI_DRAFT_ERROR
            ) {
              history.push(url('ContractCreatePage', { uuid }))
            } else {
              history.push(url('ContractDetailsPage', { uuid }))
            }
            return
        }
      },
      [url, history]
    )

    return { navigate }
  }
